import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Layout from "@/components/Layout";
import { useI18n } from "@/i18n";

export default function NotFound() {
  const { t } = useI18n();

  // Inject a noindex robots meta while 404 is displayed.
  useEffect(() => {
    const tag = document.createElement("meta");
    tag.name = "robots";
    tag.content = "noindex, follow";
    tag.setAttribute("data-mt-404", "1");
    document.head.appendChild(tag);
    return () => {
      document.querySelectorAll('meta[data-mt-404="1"]').forEach((n) => n.remove());
    };
  }, []);

  return (
    <Layout seoTitle="404">
      <section className="min-h-[70vh] flex items-center">
        <div className="container-mt text-center">
          <p className="kicker mb-6 justify-center flex">— ERROR</p>
          <h1 className="h-display text-8xl md:text-9xl text-brand-lime mb-6">404</h1>
          <h2 className="h-display text-3xl md:text-4xl text-white mb-4">{t("notFound.title")}</h2>
          <p className="text-zinc-400 mb-10">{t("notFound.subtitle")}</p>
          <Link to="/" className="btn-primary" data-testid="404-back">
            <ArrowLeft size={16} /> {t("notFound.cta")}
          </Link>
        </div>
      </section>
    </Layout>
  );
}
